import React from 'react'
import Container from '../Container'

export default function General() {
  return (
    <div>
      <Container/>
    </div>
  )
}
